import React from "react";
import { IResourceComponentsProps, BaseRecord } from "@refinedev/core";
import Cw8List from "components/cw8/Cw8List";

export const BibliotecaVirtualList: React.FC<IResourceComponentsProps> = () => {
    const resourceName = "bibliotecaVirtual"
    return (
        <Cw8List resourceName={resourceName} />
    );
};
